import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomLoader } from "../../components";
import { useGetLastBlogPostsQuery } from "../../redux/slices/dashboardApiSlice";

const QuickAccessPanel = () => {
  const { t } = useTranslation();
  const {
    data: blogPosts,
    isLoading: blogPostsLoading,
    refetch: refetchBlogPosts,
  } = useGetLastBlogPostsQuery();

  useEffect(() => {
    refetchBlogPosts();
  }, [refetchBlogPosts]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    const formattedDate = date.toLocaleDateString("fr-FR");
    const formattedTime = date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${formattedDate} à ${formattedTime}`;
  };

  return (
    <div>
      <h2 className="text-black text-xl font-bold ">
        {t("last-posts", "Derniers articles")}
      </h2>

      {blogPostsLoading ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"65vh"}
        >
          <CustomLoader />
        </Box>
      ) : (
        <div className="w-full mt-2">
          {blogPosts?.data.length > 0 ? (
            blogPosts?.data.map((blogPost) => {
              return (
                <Link
                  key={`blog-post-${blogPost.id}`}
                  to={`${window.location.origin}/post-editor/${blogPost.id}`}
                  className="w-full relative flex flex-col mt-3 no-underline text-gray-700 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 cursor-pointer  hover:border-blue-50"
                >
                  <div className="p-3">
                    <h5 className="block mb-2 font-sans antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                      {blogPost.h1_title || "Nouvel article"}
                    </h5>
                    {blogPost.subject && (
                      <p className="block font-sans text-sm antialiased font-light leading-relaxed text-inherit">
                        {blogPost.subject.length > 77
                          ? `${blogPost.subject.slice(0, 77)}...`
                          : blogPost.subject}
                      </p>
                    )}
                    <div className="flex justify-end mt-2">
                      <div className="bg-gray-100 text-gray-700 text-[14px] text-center">
                        {blogPost.last_update_date === blogPost.creation_date
                          ? "Créé le "
                          : "Dernière modification le "}
                        {formatDate(blogPost.last_update_date)}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <p className="block font-sans text-sm antialiased font-light leading-relaxed text-inherit col-span-2">
              {t(
                "no-last-blog-posts",
                "Aucun article de blog n'a été créé récemment !"
              )}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default QuickAccessPanel;
